export var Authorities;
(function (Authorities) {
    Authorities["ROLE_OWNER"] = "ROLE_OWNER";
    Authorities["ROLE_EMPLOYEE"] = "ROLE_EMPLOYEE";
    Authorities["PRIVILEGE_ORDER_STATISTICS"] = "PRIVILEGE_ORDER_STATISTICS";
    Authorities["PRIVILEGE_DELETE_TAXRATE"] = "PRIVILEGE_DELETE_TAXRATE";
})(Authorities || (Authorities = {}));
